import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFilter, updateFilter, deleteFilter } from "../services/filterApi";

export function useCreateFilter(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createFilter,
    onSuccess: (data) => {
      console.log(`Filter ${data.name} has been created successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateFilter(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFilter,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`Filter ${data.name} has been updated successfully!`);
      queryClient.setQueriesData({ queryKey: [queryData], exact: false }, (old) =>
        old?.map((item) => (item.public_id === data.public_id ? data : item)),
      );
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteFilter(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteFilter,
    onSuccess: (_, publicId) => {
      console.log(`Filter with ID ${publicId} has been deleted successfully!`);
      queryClient.setQueryData(queryData, (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.(publicId);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
